import { Flex, FlexProps } from "@chakra-ui/react";
import React from "react";

const GridContainer: React.FC<FlexProps> = (props) => {
  return <Flex w="full" px="24px" {...props}></Flex>;
};

export default GridContainer;
